module.exports = "https://cdn.realtymogul.com/static/media/chart_diversified.f2fad0f2.jpg";